<template>
    <BreadCrumb PageTitle="Point des des places louées" />
    <EtatContratParUsager />
  </template>
  
  <script lang="ts">
    import { defineComponent } from "vue";
  
    import BreadCrumb from "../../components/Common/BreadCrumb.vue";
    import EtatContratParUsager from "../../components/Etats/EtatContratParUsager.vue";

  
    export default defineComponent({
      name: "EtatContratParUsagerPage",
      components: {
        BreadCrumb,
        EtatContratParUsager,
      },
    });
  </script>